export default {"src":"/_next/static/media/glassdoor-star.4c4eb84f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};